export function doseSpotPrescriptionsQueryKey(patientId: string) {
  return ['dosespot-prescriptions', { patientId }] as const
}
